import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/ui/select";
import type { AiModel } from "@/src/types/ai.zod";
import { useTranslation } from "@/src/i18n/client";
import { Label } from "../ui/label";

interface ProviderSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  providers: AiModel[];
}

export function ProviderSelect({
  value,
  onValueChange,
  providers
}: ProviderSelectProps) {
  const { t } = useTranslation();
  
  // Find the selected provider to display its label
  const selectedProvider = providers.find(provider => provider.id === value);
  const displayValue = selectedProvider?.label;
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
      <Label
        htmlFor="provider-select"
        className="block text-sm font-medium text-gray-900 dark:text-white mb-0 w-full sm:w-28"
      >
        {t('homePage.providerSelect.label')}
      </Label>
      <div className="w-full sm:flex-1 min-w-0">
        <Select
          value={value}
          onValueChange={(value) => value && onValueChange(value)}
        >
          <SelectTrigger
            id="provider-select"
            className="w-full min-w-0 rounded-md border border-input bg-background px-3 text-sm text-foreground shadow-sm focus:border-primary focus:ring-2 focus:ring-primary/20 dark:bg-background dark:text-foreground dark:border-input"
          >
            {displayValue || <span className="text-muted-foreground">{t('homePage.providerSelect.placeholder')}</span>}
          </SelectTrigger>
          <SelectContent>
            {providers.map((provider: AiModel) => (
              <SelectItem
                key={provider.id}
                value={provider.id ?? ""}
              >
                {provider.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
